import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=06ce7398&scoped=true&"
import script from "./configDialog.vue?vue&type=script&lang=js&"
export * from "./configDialog.vue?vue&type=script&lang=js&"
import style0 from "./configDialog.vue?vue&type=style&index=0&id=06ce7398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce7398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ce7398')) {
      api.createRecord('06ce7398', component.options)
    } else {
      api.reload('06ce7398', component.options)
    }
    module.hot.accept("./configDialog.vue?vue&type=template&id=06ce7398&scoped=true&", function () {
      api.rerender('06ce7398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navi/components/configDialog.vue"
export default component.exports